import './styles/MyEvents.scss';
import { System_DeviceOrientationMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { MemberUser_TypeMap, MyEvents_PageMap, MyEvents_ShareModeMap, MyEvents_SortModeMap, Payment_StatusMap, EventCategory_CategoryTypeMap, EventItem_TypeMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect, createRef, ReactElement } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Mediastore } from '@agorapulse/capacitor-mediastore';
import { Share } from '@capacitor/share';
import QRCode from "react-qr-code";
import html2canvas from 'html2canvas';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
import SelectionBox from '../../components/SelectionBox';
import { Browser } from '@capacitor/browser';

//classes
import Event from '../../exClasses/event';
import EventRegistration from '../../exClasses/eventRegistration';
import SelectionList from '../../classes/selectionList';
import EventCategory from '../../exClasses/eventCategory';
import EventFee from '../../exClasses/eventFee';
import Payment from '../../exClasses/payment';
import EventRegistrationReferral from '../../exClasses/eventRegistrationReferral';
import EventItem from '../../exClasses/eventItem';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//handlers
import SwipeOverscrollHandler from '../../handlers/SwipeOverscrollHandler';

//mui
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import SearchIcon from '@mui/icons-material/Search';
// import FestivalIcon from '@mui/icons-material/Festival';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoIcon from '@mui/icons-material/Info';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
// import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import FeedIcon from '@mui/icons-material/Feed';


//graphics
// import DefaultImage from '../../assets/images/logos/DefaultImage.jpg';
import DefaultImage from '../../assets/images/general/defaultImage.jpg';
import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
import { isPlatform } from '@ionic/react';
import MemberUser from '../../classes/memberUser';
// import MemberUser from '../../classes/memberUser';

const nonstate = {
    // pageMap: {
    //     UPCOMING: 0,
    //     PAST: 1,
    //     VIEW: 2,
    //     SNAP: 3
    // },
    // shareModeMap: {
    //     SHARE: 0,
    //     DOWNLOAD: 1
    // },
    // sortModeMap: {
    //     ACCENDING: 0,
    //     DESCENDING: 1
    // }
    eventFetchBatchSize: 10
}

class AttachmentMap {
    public fileName: string = '';
    public source: string = ''; //can be base64String or urlSource
    public label: string = '';
}

interface Props {

}

const MyEvents: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState<number>(MyEvents_PageMap.UPCOMING);
    // const [userUpcomingEventRegistrations, SetUserUpcomingEventRegistrations] = useState<EventRegistration[]>([] as EventRegistration[]); ---deprecated of unuse
    const [userUpcomingEvents, SetUserUpcomingEvents] = useState<Event[]>([] as Event[]);
    const [userUpcomingRegistrationPayments, SetUserUpcomingRegistrationPayments] = useState<Payment[]>([] as Payment[]);
    // const [userPastEventRegistrations, SetUserPastEventRegistrations] = useState<EventRegistration[]>([] as EventRegistration[]); ---deprecated of unuse
    const [userPastEvents, SetUserPastEvents] = useState<Event[]>([] as Event[]);
    const [userPastRegistrationPayments, SetUserPastRegistrationPayments] = useState<Payment[]>([] as Payment[]);
    // const [eventRegistrationFetchCounts, SetEventRegistrationFetchCounts] = useState<any>({ upcoming: 0, past: 0 }); --deprecated
    // const [regRefIDs, SetRegRefIDs] = useState<string[]>([] as string[]); ---deprecated to eventRegistrationReferrals
    const [qrCardIndex, SetQrCardIndex] = useState(0);
    const [preSearchString, SetPreSearchString] = useState('');
    const [selectionList_eventCategory, SetSelectionList_eventCategory] = useState<SelectionList[]>([] as SelectionList[]);
    const [currentSelectedEvent, SetCurrentSelectedEvent] = useState<Event>({} as Event);
    const [currentSelectedEventAttachments, SetCurrentSelectedEventAttachments] = useState<AttachmentMap[]>([] as AttachmentMap[]);
    const [eventRegistrationReferrals, SetEventRegistrationReferrals] = useState<EventRegistrationReferral[]>([] as EventRegistrationReferral[]);
    const [filter_searchString, SetFilter_searchString] = useState('');
    const [filter_eventCategory, SetFilter_eventCategory] = useState('');
    const [upcomingEventsAltImgsErr, SetUpcomingEventsAltImgsErr] = useState([] as boolean[]);
    const [pastEventsAltImgsErr, SetPastEventsAltImgsErr] = useState([] as boolean[]);
    const [detailsImgErr, SetDetailsImgErr] = useState(false as boolean);

    //references for PAGE UPCOMING_PAST

    //references
    const eventScrollRef = useRef<any>(null);
    const pageRef = useRef<number>(-1);
    const prevPageRef = useRef<number>(-1);
    const upcomingEventsAltImgsErrRef = useRef<boolean[]>(upcomingEventsAltImgsErr);
    const pastEventsAltImgsErrRef = useRef<boolean[]>(pastEventsAltImgsErr);
    //references for PAGE TICKETS_SNAP
    const qrCardScrollMaskRef = useRef<any>(null);
    const eventRegistrationReferralsRef = useRef<EventRegistrationReferral[]>([] as EventRegistrationReferral[]);
    const qrCardIndexRef = useRef(qrCardIndex);
    const qrCardRefs = useRef<any>([]);
    const ticketElemRef = useRef<any>(null);
    const shareModeRef = useRef<number>(MyEvents_ShareModeMap.SHARE);
    const timeoutRef_ticketElemToCanvas = useRef<any>(null);
    //router objs
    const history = useHistory();
    const location = useLocation();
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('MyEventTest: ' + JSON.stringify(eventRegistrationReferrals));
    // }, [eventRegistrationReferrals]);

    //watch for currentSelected event fetch eventRegRefferals
    useEffect(() => {
        //fetchRegRefID
        if (Object.keys(currentSelectedEvent).length > 0) {
            databaseInterfaceController.Queue('fetchEventRegistrationReferrals', [
                ['fetchEventRegistrationReferrals', 'true'],
                ['memberID', appContext.user.memberID],
                ['eventID', currentSelectedEvent.eventID]
            ]);
            databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                ['fetchEventItemByEventIDAndType', 'true'],
                ['eventID', currentSelectedEvent.eventID],
                ['type', EventItem_TypeMap.ATTACHMENT]
            ]);
        }
        //reset detailsImgErr
        SetDetailsImgErr(false);
    }, [currentSelectedEvent]);

    //watch for pageMode and preSelectedEvent from path
    useEffect(() => {
        const pathNameArr = location.pathname.split('/');
        if (pathNameArr.length > 2) {
            SetPage(MyEvents_PageMap.DETAILS);
            databaseInterfaceController.Queue('fetchEventByID', [
                ['fetchEventByID', 'true'],
                ['eventID', pathNameArr[3]]
            ]);
        }
    }, [location.pathname]);

    //watch for eventCategories update filterSelectionList
    useEffect(() => {
        const eventCategorySelectionList = [{ key: '', value: 'all categories' }] as SelectionList[];
        exAppContext.eventCategories.map((eventCategory: EventCategory) => {
            if (eventCategory.event_category_type != EventCategory_CategoryTypeMap.MEETING)
                eventCategorySelectionList.push({ key: eventCategory.event_categoryID, value: eventCategory.event_category_name } as SelectionList);
        });
        SetSelectionList_eventCategory([...eventCategorySelectionList]);
    }, [exAppContext.eventCategories]);

    //watch for events update upcomingEvents
    useEffect(() => {
        let events = [] as Event[];

        //by seting sortmode ascending, nearer events will be shown on top
        switch (page) {
            case MyEvents_PageMap.UPCOMING:
                events = userUpcomingEvents;
                SortEventsByDate(
                    events,
                    MyEvents_SortModeMap.ASCENDING
                );
                if (JSON.stringify(events) != JSON.stringify(userUpcomingEvents))
                    SetUserUpcomingEvents([...events]);
                break;
            case MyEvents_PageMap.PAST:
                events = userPastEvents;
                SortEventsByDate(
                    userPastEvents,
                    MyEvents_SortModeMap.DESCENDING
                );
                if (JSON.stringify(events) != JSON.stringify(userPastEvents))
                    SetUserPastEvents([...events]);
                break;
        }

        //reset altImgsErr
        upcomingEventsAltImgsErrRef.current = [];
        userUpcomingEvents.map((event: Event) => {
            upcomingEventsAltImgsErrRef.current.push(false); //no errors
        });
        SetUpcomingEventsAltImgsErr([...upcomingEventsAltImgsErrRef.current]);

        pastEventsAltImgsErrRef.current = [];
        userPastEvents.map((event: Event) => {
            pastEventsAltImgsErrRef.current.push(false); //no errors
        });
        SetPastEventsAltImgsErr([...pastEventsAltImgsErrRef.current]);

    }, [userUpcomingEvents, userPastEvents]);

    //watch for eventRegistrationFetchCounts update fetchUpcoming or Pasts events
    // useEffect(() => {
    //     if (
    //         JSON.stringify(prevEventRegistrationFetchCountsRef.current != JSON.stringify(eventRegistrationFetchCounts))
    //         &&
    //         ((page == MyEvents_PageMap.UPCOMING && !eventRegistrationFetchCountsIsMaxRef.current.upcoming)
    //             || (page == MyEvents_PageMap.PAST && !eventRegistrationFetchCountsIsMaxRef.current.past))
    //     ) {
    //         const fetchMode = (page == MyEvents_PageMap.UPCOMING ? 'fetchUserUpcomingEventRegistrations' : 'fetchUserPastEventRegistrations');
    //         // const fetchCount = (page == MyEvents_PageMap.UPCOMING ? eventRegistrationFetchCounts.upcoming : eventRegistrationFetchCounts.past); --deprecated of unused
    //         //fetch events
    //         databaseInterfaceController.Queue(fetchMode, [
    //             [fetchMode, 'true'],
    //             ['memberID', appContext.user.memberID],
    //             ['dateNow', IonDateString(new Date())]
    //         ]);
    //         prevEventRegistrationFetchCountsRef.current = eventRegistrationFetchCounts;
    //     }
    // }, [eventRegistrationFetchCounts]); ---deprecated of unused

    //watch for qrCard index change
    useEffect(() => {
        if (qrCardRefs.current[qrCardIndex] != undefined) {
            qrCardRefs.current[qrCardIndex].scrollIntoView({ inline: 'center' });
        }
    }, [qrCardIndex, page]);

    //watch for page change update headerTitle & headerBackAction
    useEffect(() => {
        if (page != pageRef.current) {

            //save page reference, so user can go back to upcoming/past from TICKETS and DETAILS page
            if (page != MyEvents_PageMap.SNAP) { //dont capture page snap
                prevPageRef.current = parseInt(pageRef.current.toString());
                pageRef.current = page;
            }

            switch (page) {
                case MyEvents_PageMap.UPCOMING:
                    appContext.SetHeaderTitle('MY EVENTS');
                    appContext.SetHeaderBackAction(() => function () { appContext.SetHeaderBackAction(history.push('/Home')) });

                    //fetch user upcoming registrations from server
                    databaseInterfaceController.Queue('fetchUserUpcomingEventRegistrations', [
                        ['fetchUserUpcomingEventRegistrations', 'true'],
                        ['memberID', appContext.user.memberID],
                        ['dateNow', IonDateString(new Date())]
                    ]);
                    break;
                case MyEvents_PageMap.PAST:
                    appContext.SetHeaderTitle('MY EVENTS');
                    appContext.SetHeaderBackAction(() => function () { appContext.SetHeaderBackAction(history.push('/Home')) });

                    //fetch user past registrations from server
                    databaseInterfaceController.Queue('fetchUserPastEventRegistrations', [
                        ['fetchUserPastEventRegistrations', 'true'],
                        ['memberID', appContext.user.memberID],
                        ['dateNow', IonDateString(new Date())]
                    ]);
                    break;
                case MyEvents_PageMap.TICKETS:
                    appContext.SetHeaderTitle('QR CODE');
                    appContext.SetHeaderBackAction(() => function () { SetPage(prevPageRef.current); });
                    break;
                case MyEvents_PageMap.DETAILS:
                    appContext.SetHeaderTitle('EVENT DETAILS');
                    appContext.SetHeaderBackAction(() => function () { SetPage(prevPageRef.current); });
                    break;
            }
        }
    }, [page]);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchEventRegistrationReferrals':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            eventRegistrationReferralsRef.current = [];
                            jsonObjs.map((obj: any) => {
                                eventRegistrationReferralsRef.current.push(new EventRegistrationReferral(
                                    obj['event_regRefID'],
                                    obj['event_registrationID'],
                                    obj['userID'],
                                    obj['public_beneficiary_id'],
                                    obj['public_beneficiary_fullname'],
                                    obj['public_beneficiary_email'],
                                    obj['public_beneficiary_phone'],
                                    obj['datetime_created'],
                                    obj['datetime_expired']
                                ));
                            });
                            SetEventRegistrationReferrals([...eventRegistrationReferralsRef.current]);
                        } else {
                            console.log('fetchRegRefIDErr: ' + res);
                        }
                        break;
                    case 'fetchEventByID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }
                            SetCurrentSelectedEvent(new Event(
                                resObj['eventID'],
                                resObj['event_categoryID'],
                                resObj['event_name'],
                                resObj['event_name_highlight_texts'],
                                resObj['event_name_highlight_colors'],
                                resObj['event_desc'],
                                resObj['event_poster'],
                                resObj['event_file'],
                                resObj['event_venue'],
                                resObj['registration_start_date'],
                                resObj['registration_end_date'],
                                resObj['early_bird_start_date'],
                                resObj['early_bird_end_date'],
                                resObj['event_start_date'],
                                resObj['event_end_date'],
                                resObj['event_schedules'],
                                resObj['max_pax'],
                                resObj['hostID'],
                                resObj['datetime_created'],
                                resObj['datetime_updated'],
                                resObj['inapp_registration'],
                                resObj['external_registration_link']
                                // resObj['attachment_base_url'],
                                // resObj['attachment_file_names']
                            ));
                        } else {
                            console.log('fetchEventByIDErr ' + res);
                        }
                        break;
                    case 'fetchUserUpcomingEventRegistrations':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            const upcomingRegistrations = [] as EventRegistration[];
                            const upcomingEvents = [] as Event[];
                            const upcomingPayments = [] as Payment[];
                            jsonObjs.map((jsonObj: any) => {
                                upcomingRegistrations.push(new EventRegistration(
                                    jsonObj['event_registrationID'],
                                    jsonObj['eventID'],
                                    jsonObj['paymentID'],
                                    jsonObj['initiatorID'],
                                    jsonObj['beneficiaryIDs'],
                                    jsonObj['doc_base_url'],
                                    jsonObj['beneficiary_doc_ics'],
                                    jsonObj['beneficiary_doc_passports'],
                                    jsonObj['dietary_options'],
                                    jsonObj['public_beneficiary_ids'],
                                    jsonObj['public_beneficiary_salutations'],
                                    jsonObj['public_beneficiary_fullnames'],
                                    jsonObj['public_beneficiary_emails'],
                                    jsonObj['public_beneficiary_phones'],
                                    jsonObj['public_beneficiary_designations'],
                                    jsonObj['public_beneficiary_doc_ics'],
                                    jsonObj['public_beneficiary_doc_passports'],
                                    jsonObj['public_beneficiary_rpm_nos'],
                                    jsonObj['public_dietary_options'],
                                    jsonObj['hrd_claim_status'],
                                    jsonObj['hrd_grant_status'],
                                    jsonObj['datetime_created'],
                                    jsonObj['event_regRefIDs']
                                ));
                                upcomingEvents.push(new Event(
                                    jsonObj['eventID'],
                                    jsonObj['event_categoryID'],
                                    jsonObj['event_name'],
                                    jsonObj['event_name_highlight_texts'],
                                    jsonObj['event_name_highlight_colors'],
                                    jsonObj['event_desc'],
                                    jsonObj['event_poster'],
                                    jsonObj['event_file'],
                                    jsonObj['event_venue'],
                                    jsonObj['registration_start_date'],
                                    jsonObj['registration_end_date'],
                                    jsonObj['early_bird_start_date'],
                                    jsonObj['early_bird_end_date'],
                                    jsonObj['event_start_date'],
                                    jsonObj['event_end_date'],
                                    jsonObj['event_schedules'],
                                    jsonObj['max_pax'],
                                    jsonObj['hostID'],
                                    jsonObj['datetime_created'],
                                    jsonObj['datetime_updated'],
                                    jsonObj['inapp_registration'],
                                    jsonObj['external_registration_link']
                                    // jsonObj['attachment_base_url'],
                                    // jsonObj['attachment_file_names']
                                ));
                                upcomingPayments.push(new Payment(
                                    jsonObj['paymentID'],
                                    jsonObj['invoice_no'],
                                    jsonObj['type'],
                                    jsonObj['status'],
                                    jsonObj['contact_salutation'],
                                    jsonObj['contact_other_salutation'],
                                    jsonObj['contact_name'],
                                    jsonObj['contact_hp'],
                                    jsonObj['contact_office_no'],
                                    jsonObj['contact_email'],
                                    jsonObj['billing_name'],
                                    jsonObj['billing_address'],
                                    jsonObj['e_invoice_pin'],
                                    jsonObj['itemIDs'],
                                    jsonObj['pax'],
                                    jsonObj['amounts'],
                                    jsonObj['datetime_created'],
                                    jsonObj['datetime_updated'],
                                    jsonObj['remarks']
                                ));
                            });
                            // SetUserUpcomingEventRegistrations([...upcomingRegistrations]); --deprecated of unuse
                            SetUserUpcomingEvents([...upcomingEvents]);
                            SetUserUpcomingRegistrationPayments([...upcomingPayments]);
                        } else {
                            console.log('fetchUserUpcomingEventRegistrationsErr: ' + res);
                        }
                        break;
                    case 'fetchUserPastEventRegistrations':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            const pastRegistrations = [] as EventRegistration[];
                            const pastEvents = [] as Event[];
                            const pastPayments = [] as Payment[];
                            jsonObjs.map((jsonObj: any) => {
                                pastRegistrations.push(new EventRegistration(
                                    jsonObj['event_registrationID'],
                                    jsonObj['eventID'],
                                    jsonObj['paymentID'],
                                    jsonObj['initiatorID'],
                                    jsonObj['beneficiaryIDs'],
                                    jsonObj['doc_base_url'],
                                    jsonObj['beneficiary_doc_ics'],
                                    jsonObj['beneficiary_doc_passports'],
                                    jsonObj['dietary_options'],
                                    jsonObj['public_beneficiary_ids'],
                                    jsonObj['public_beneficiary_salutations'],
                                    jsonObj['public_beneficiary_fullnames'],
                                    jsonObj['public_beneficiary_emails'],
                                    jsonObj['public_beneficiary_phones'],
                                    jsonObj['public_beneficiary_designations'],
                                    jsonObj['public_beneficiary_doc_ics'],
                                    jsonObj['public_beneficiary_doc_passports'],
                                    jsonObj['public_beneficiary_rpm_nos'],
                                    jsonObj['public_dietary_options'],
                                    jsonObj['hrd_claim_status'],
                                    jsonObj['hrd_grant_status'],
                                    jsonObj['datetime_created'],
                                    jsonObj['event_regRefIDs']
                                ));
                                pastEvents.push(new Event(
                                    jsonObj['eventID'],
                                    jsonObj['event_categoryID'],
                                    jsonObj['event_name'],
                                    jsonObj['event_name_highlight_texts'],
                                    jsonObj['event_name_highlight_colors'],
                                    jsonObj['event_desc'],
                                    jsonObj['event_poster'],
                                    jsonObj['event_file'],
                                    jsonObj['event_venue'],
                                    jsonObj['registration_start_date'],
                                    jsonObj['registration_end_date'],
                                    jsonObj['early_bird_start_date'],
                                    jsonObj['early_bird_end_date'],
                                    jsonObj['event_start_date'],
                                    jsonObj['event_end_date'],
                                    jsonObj['event_schedules'],
                                    jsonObj['max_pax'],
                                    jsonObj['hostID'],
                                    jsonObj['datetime_created'],
                                    jsonObj['datetime_updated'],
                                    jsonObj['inapp_registration'],
                                    jsonObj['external_registration_link']
                                    // jsonObj['attachment_base_url'],
                                    // jsonObj['attachment_file_names']
                                ));
                                pastPayments.push(new Payment(
                                    jsonObj['paymentID'],
                                    jsonObj['invoice_no'],
                                    jsonObj['type'],
                                    jsonObj['status'],
                                    jsonObj['contact_salutation'],
                                    jsonObj['contact_other_salutation'],
                                    jsonObj['contact_name'],
                                    jsonObj['contact_hp'],
                                    jsonObj['contact_office_no'],
                                    jsonObj['contact_email'],
                                    jsonObj['billing_name'],
                                    jsonObj['billing_address'],
                                    jsonObj['e_invoice_pin'],
                                    jsonObj['itemIDs'],
                                    jsonObj['pax'],
                                    jsonObj['amounts'],
                                    jsonObj['datetime_created'],
                                    jsonObj['datetime_updated'],
                                    jsonObj['remarks']
                                ));
                            });
                            // SetUserPastEventRegistrations([...pastRegistrations]); ---deprecated of unuse
                            SetUserPastEvents([...pastEvents]);
                            SetUserPastRegistrationPayments([...pastPayments]);
                        } else {
                            console.log('fetchUserUpcomingEventRegistrationsErr: ' + res);
                        }
                        break;
                    case 'fetchEventItemByEventIDAndType':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }

                            const eventItem = new EventItem(
                                resObj['itemID'],
                                resObj['eventID'],
                                resObj['base_url'],
                                resObj['file_names'],
                                resObj['datetime_expired'],
                                resObj['type']
                            );

                            const eventAttachments = [] as AttachmentMap[];
                            eventItem.file_names.map((fileName: string, i: number) => {
                                eventAttachments.push({
                                    source: eventItem.base_url + fileName,
                                    fileName: fileName,
                                    label: fileName
                                } as AttachmentMap);
                            });
                            SetCurrentSelectedEventAttachments([...eventAttachments]);
                        } else {
                            console.log('fetchEventItemByEventIDAndTypeErr: ' + res);
                        }
                        break;
                }
            };
            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchEventRegistrationReferrals':
                case 'fetchEventByID':
                case 'fetchUserUpcomingEventRegistrations':
                case 'fetchUserPastEventRegistrations':
                case 'fetchEventItemByEventIDAndType':
                    ExecuteDatabaseResultAction();
                    break;
            }

        }
    }, [appContext.databaseActionModeQueue[0], appContext.databaseResultAction]);

    //ui functions
    const OnNavigateToNextQr = () => {
        if (qrCardIndexRef.current + 1 < eventRegistrationReferralsRef.current.length) {
            qrCardIndexRef.current += 1;
            SetQrCardIndex(qrCardIndexRef.current);
        }
    }
    const OnNavigateToPrevQr = () => {
        if (qrCardIndexRef.current - 1 >= 0) {
            qrCardIndexRef.current -= 1;
            SetQrCardIndex(qrCardIndexRef.current);
        }
    }
    const OnShareBtnClicked = () => {
        shareModeRef.current = MyEvents_ShareModeMap.SHARE;
        SnapRegistrationInfoTicket();
    }
    const OnDownloadBtnClicked = () => {
        shareModeRef.current = MyEvents_ShareModeMap.DOWNLOAD;
        SnapRegistrationInfoTicket();
    }
    const OnSearchBtnClicked = () => {
        SetFilter_searchString(preSearchString);
    }
    const OnPaymentPendingClicked = (payment: Payment) => {
        const payBeforeDate = payment.datetime_created != null ? payment.datetime_created : new Date();
        payBeforeDate.setDate(payBeforeDate.getDate() + 14);
        appContext.SetPopupMessage('Please pay before \n' + IonDateString(payBeforeDate, IonDateFormat.LONG_DATE) + ' or the registration might be forfeit.');
    }
    const OnEventTicketClicked = (event: Event) => {
        SetCurrentSelectedEvent(event);
        SetPage(MyEvents_PageMap.TICKETS);
    }
    const OnEventDetailsClicked = (event: Event) => {
        SetCurrentSelectedEvent(event);
        SetPage(MyEvents_PageMap.DETAILS);
    }

    //render functions
    const RenderPages = () => {
        switch (page) {
            default:
            case MyEvents_PageMap.UPCOMING:
                return RenderUpcomingEvents();
            case MyEvents_PageMap.PAST:
                return RenderPastEvents();
            case MyEvents_PageMap.DETAILS:
                return RenderEventDetails();
            case MyEvents_PageMap.TICKETS:
                return RenderEventRegistrationTickets();
            case MyEvents_PageMap.SNAP:
                return RenderSnapRegistrationTicket();
        }
    }
    const RenderTopOptions = () => {
        switch (page) {
            case MyEvents_PageMap.UPCOMING:
            case MyEvents_PageMap.PAST:
                return (
                    <Fragment>
                        <div className='option-panel-row'>
                            <div className='search-bar'>
                                <input className='search-bar-in' onChange={(e: any) => { SetPreSearchString(e.target.value) }} value={preSearchString} onFocus={() => SetPreSearchString('')} placeholder='search' />
                                <button className='search-btn' onClick={() => OnSearchBtnClicked()}><SearchIcon /></button>
                            </div>
                            {/* <button className='ppkm-events-btn' onClick={() => history.push('/Events')}>
                                <FestivalIcon />
                                PPKM<br />Events
                            </button> --deprecated*/}
                            <button className='event-registrations-btn ex' onClick={() => history.push('/EventRegistrations')}>
                                <AppRegistrationIcon />
                                Event<br />Registrations
                            </button>
                        </div>
                        <div className='option-panel-row'>
                            <button className={'option-btn ' + (page == MyEvents_PageMap.UPCOMING ? 'selected' : '')} onClick={() => SetPage(MyEvents_PageMap.UPCOMING)}>Current</button>
                            <button className={'option-btn ' + (page == MyEvents_PageMap.PAST ? 'selected' : '')} onClick={() => SetPage(MyEvents_PageMap.PAST)}>Past</button>
                            <div className={'option-indicator ' + (GetKeyOfObjectByValue(MyEvents_PageMap, page))} />
                        </div>
                    </Fragment>
                );
            case MyEvents_PageMap.TICKETS:
                return (
                    <Fragment>

                    </Fragment>
                )
        }
    }
    const RenderBottomOptions = () => {
        switch (page) {
            case MyEvents_PageMap.UPCOMING:
            case MyEvents_PageMap.PAST:
                return (
                    <Fragment>
                        <div className='filter-panel'>
                            <span className='filter-panel-title'>Filter By</span>
                            <SelectionBox selectionList={selectionList_eventCategory} selectingKey={filter_eventCategory} SetSelectingKey={SetFilter_eventCategory} direction='up' />
                        </div>
                        <div className='scroll-nav-panel'>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: 0, behaviour: 'smooth' }); }}><ArrowDropUpIcon /></button>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: eventScrollRef.current.scrollHeight, behaviour: 'smooth' }); }}><ArrowDropDownIcon /></button>
                        </div>
                    </Fragment>
                )
        }
    }
    const RenderUpcomingEvents = () => {
        const filteredEvents = FilterEventsBySearchString(
            FilterEventsByCategory(
                FilterEventsMergeSameEvents(
                    userUpcomingEvents
                )
            )
        );
        return (
            <Fragment>
                <div className='events-scroll' ref={eventScrollRef}>
                    {
                        filteredEvents.length > 0 ?
                            filteredEvents.map((event: Event, i: number) => RenderEventCard(event, i))
                            :
                            <span className='events-scroll-lbl'>There're no current events found</span>
                    }
                </div>
            </Fragment>
        )
    }
    const RenderPastEvents = () => {
        const filteredEvents = FilterEventsBySearchString(
            FilterEventsByCategory(
                FilterEventsMergeSameEvents(
                    userPastEvents
                )
            )
        );

        return (
            <Fragment>
                <div className='events-scroll' ref={eventScrollRef}>
                    {
                        filteredEvents.length > 0 ?
                            filteredEvents.map((event: Event, i: number) => RenderEventCard(event, i))
                            :
                            <span className='events-scroll-lbl'>There're no past events found</span>
                    }
                </div>
            </Fragment>
        )
    }
    const RenderEventCard = (event: Event, i: number) => {
        const paymentInfo = (
            page == MyEvents_PageMap.UPCOMING ?
                userUpcomingRegistrationPayments[i]
                :
                userPastRegistrationPayments[i]
        );
        return (
            <div className='event-card' key={'event-card-' + i}>
                {
                    page == MyEvents_PageMap.UPCOMING ?
                        (
                            upcomingEventsAltImgsErr[i] != undefined && upcomingEventsAltImgsErr[i] ?
                                <img className='event-card-img' src={DefaultImage} />
                                :
                                <img className='event-card-img' src={event.event_poster} onError={() => {
                                    setTimeout(() => {
                                        upcomingEventsAltImgsErrRef.current[i] = true;
                                        SetUpcomingEventsAltImgsErr([...upcomingEventsAltImgsErrRef.current]);
                                    }, 10 + Math.random() * 500);
                                }} />
                        )
                        :
                        (
                            page == MyEvents_PageMap.PAST ?
                                (
                                    pastEventsAltImgsErr[i] != undefined && pastEventsAltImgsErr[i] ?
                                        <img className='event-card-img' src={DefaultImage} />
                                        :
                                        <img className='event-card-img' src={event.event_poster} onError={() => {
                                            setTimeout(() => {
                                                pastEventsAltImgsErrRef.current[i] = true;
                                                SetPastEventsAltImgsErr([...pastEventsAltImgsErrRef.current]);
                                            }, 10 + Math.random() * 500);
                                        }} />
                                )
                                :
                                null
                        )
                }
                <div className='event-card-col'>
                    <span className='event-card-title'>{event.event_name}</span>
                    <div className='event-card-row'>
                        <LocationOnIcon />
                        <span className='event-card-lbl'>{event.event_venue}</span>
                    </div>
                    <div className='event-card-row'>
                        <DateRangeIcon />
                        <span className='event-card-lbl'>{IonDateString(event.event_start_date, IonDateFormat.LONG_DATE)} - {IonDateString(event.event_end_date, IonDateFormat.LONG_DATE)}</span>
                    </div>
                    {/* <div className='event-card-row'>
                        <button className='event-card-btn' onClick={() => { SetCurrentSelectedEvent(event); SetPage(MyEvents_PageMap.TICKETS); }}>View Tickets<ConfirmationNumberIcon /></button>
                    </div> */}
                </div>
                <div className='background-ui-mask' onClick={() => OnEventDetailsClicked(event)} />
                {/* <div className='event-card-option-panel'>
                    {
                        paymentInfo.status == Payment_StatusMap.PENDING ?
                            <button className='event-card-option-btn pending' onClick={() => OnPaymentPendingClicked(paymentInfo)}>Payment Pending <InfoIcon /></button>
                            :
                            (
                                paymentInfo.status == Payment_StatusMap.PAID ?
                                    <button className='event-card-option-btn' onClick={() => OnEventTicketClicked(event)}>Event Tickets<ConfirmationNumberIcon /></button>
                                    :
                                    <button className='event-card-option-btn' onClick={() => OnEventTicketClicked(event)}>Payment Failed <InfoIcon /></button>
                            )
                    }
                    <button className='event-card-option-btn' onClick={() => OnEventDetailsClicked(event)}>Event Details<ArrowForwardIosIcon /></button>
                </div> ---deprecated*/}
                {/* <button className='event-card-nav-btn'><ArrowForwardIosIcon /></button> */}
            </div>
        )
    }
    const RenderEventRegistrationTickets = () => {
        return (
            <div className='event-registration-info'>
                <div className='event-qr-card-scroll'>
                    {
                        eventRegistrationReferrals.map((eventRegistrationReferral: EventRegistrationReferral, i: number) => {
                            return (
                                <div ref={(el: any) => (qrCardRefs.current[i] = el)} className={'event-qr-card ' + (qrCardIndex == i ? 'selected' : '')} key={'event-qr-card-' + i}>
                                    <QRCode value={eventRegistrationReferral.event_regRefID} />
                                    <span className='event-qr-lbl ex'>{eventRegistrationReferral.event_regRefID}</span>
                                    <span className='event-qr-lbl'>Name: {eventRegistrationReferral.userID.length > 0 ? GetMembershipUserByID(eventRegistrationReferral.userID).name : eventRegistrationReferral.public_beneficiary_fullname}</span>
                                    <span className='event-qr-lbl'>NRIC: {eventRegistrationReferral.userID.length > 0 ? NRICMask(GetMembershipUserByID(eventRegistrationReferral.userID).nric) : NRICMask(eventRegistrationReferral.public_beneficiary_id)}</span>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='event-qr-card-scroll-mask' ref={qrCardScrollMaskRef} />
                <span className='event-title-lbl'>{currentSelectedEvent.event_name}</span>
                <span className='qr-card-count'>{(qrCardIndex + 1)}/{eventRegistrationReferrals.length}</span>
                <div className='event-registration-option-panel'>
                    <button className='event-registration-option-btn' onClick={() => OnShareBtnClicked()}><ShareIcon />Share</button>
                    <button className='event-registration-option-btn' onClick={() => OnDownloadBtnClicked()}><DownloadIcon />Download</button>
                </div>
            </div>
        )
    }
    const RenderSnapRegistrationTicket = () => {
        TicketElemToCanvas();
        const registrationReferral = eventRegistrationReferrals[qrCardIndexRef.current];

        return (
            <div className='snap-registration-ticket' ref={ticketElemRef}>
                <img className='logo-img' src={PPKMLogo} />
                <div className='qr-block'>
                    <QRCode value={registrationReferral.event_regRefID} />
                    <span className='qr-block-lbl ex'>Reference: {registrationReferral.event_regRefID}</span>
                    <span className='qr-block-lbl'>Name: {registrationReferral.userID.length > 0 ? GetMembershipUserByID(eventRegistrationReferrals[qrCardIndexRef.current].userID).name : eventRegistrationReferrals[qrCardIndexRef.current].public_beneficiary_fullname}</span>
                    <span className='qr-block-lbl'>NRIC: {registrationReferral.userID.length > 0 ? NRICMask(GetMembershipUserByID(eventRegistrationReferrals[qrCardIndexRef.current].userID).nric) : NRICMask(eventRegistrationReferrals[qrCardIndexRef.current].public_beneficiary_id)}</span>
                </div>
                <div className='info-block'>
                    <div className='info-block-row'>
                        <span className='info-block-lbl'>Event Name</span>
                        <span className='info-block-txt'>{currentSelectedEvent.event_name}</span>
                    </div>
                    <div className='info-block-row'>
                        <span className='info-block-lbl'>Venue</span>
                        <span className='info-block-txt'>{currentSelectedEvent.event_venue}</span>
                    </div>
                    <div className='info-block-row'>
                        <span className='info-block-lbl'>Start</span>
                        <span className='info-block-txt'>{currentSelectedEvent.event_start_datetime! ? IonDateString(currentSelectedEvent.event_start_datetime) : ''}</span>
                    </div>
                    <div className='info-block-row'>
                        <span className='info-block-lbl'>End</span>
                        <span className='info-block-txt'>{currentSelectedEvent.event_end_datetime! ? IonDateString(currentSelectedEvent.event_end_datetime) : ''}</span>
                    </div>
                </div>
            </div>
        )
    }
    const RenderEventDetails = () => {
        if (Object.keys(currentSelectedEvent).length > 0) {
            return (
                <div className='details-card'>
                    {
                        !detailsImgErr ?
                            <img className='details-card-img' src={currentSelectedEvent.event_poster} onError={() => SetDetailsImgErr(true)} />
                            :
                            <img className='details-card-img' src={DefaultImage} />
                    }
                    <span className='details-card-title'>{currentSelectedEvent.event_name}</span>
                    <div className='details-card-row'>
                        <LocationOnIcon />
                        <span className='details-card-lbl'>{currentSelectedEvent.event_venue}</span>
                    </div>
                    <div className='details-card-row'>
                        <DateRangeIcon />
                        <span className='details-card-lbl'>From {IonDateString(currentSelectedEvent.event_start_date, IonDateFormat.LONG_DATE)} <br /> To {IonDateString(currentSelectedEvent.event_start_date, IonDateFormat.LONG_DATE)}</span>
                    </div>
                    <div className='details-card-row'>
                        <AccessTimeIcon />
                        {/*<span className='details-card-lbl'>
                            {
                                IonDateString(currentSelectedEvent.event_start_datetime, IonDateFormat.TIME_12)
                                + ' - ' +
                                IonDateString(currentSelectedEvent.event_end_datetime, IonDateFormat.TIME_12)
                            }
                        </span>*/}
                        <div className='details-card-table'>
                            <div className='details-card-table-row'>
                                <span className='details-card-table-title'>Date</span>
                                <span className='details-card-table-title'>Start</span>
                                <span className='details-card-table-title'>End</span>
                            </div>
                            {
                                currentSelectedEvent.event_schedules.map((dailySchedule: any[]) => {
                                    return (
                                        <div className='details-card-table-row'>
                                            <span className='details-card-table-lbl'>{IonDateString(dailySchedule[0], IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
                                            <span className='details-card-table-lbl'>{IonDateString(dailySchedule[0], IonDateFormat.TIME_12)}</span>
                                            <span className='details-card-table-lbl'>{IonDateString(dailySchedule[1], IonDateFormat.TIME_12)}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {
                        currentSelectedEvent.event_desc.replace(/\s/g, '').length > 0 ?
                            <Fragment>
                                <span className='details-card-title'>Descriptions</span>
                                <div className='details-card-row'>
                                    <span className='details-card-paragraph'>{currentSelectedEvent.event_desc}</span>
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    {
                        currentSelectedEvent.event_file.length > 0 ?
                            <div className='details-card-row'>
                                <button className='more-details-btn' onClick={async () => { await Browser.open({ url: currentSelectedEvent.event_file }); }}>View More Details <FeedIcon /></button>
                            </div>
                            :
                            null
                    }
                    {
                        currentSelectedEventAttachments.length > 0 ?
                            <Fragment>
                                <span className='details-card-title'>Attachments</span>
                                {
                                    currentSelectedEventAttachments.map((attachment: AttachmentMap, i: number) => {
                                        return (
                                            <div className='details-card-row' key={'details-card-row-' + i}>
                                                <button className='details-card-attachment-btn' onClick={async() => { await Browser.open({ url: attachment.source })}}>
                                                    {attachment.fileName}
                                                </button>
                                            </div>
                                        )
                                    })
                                }
                            </Fragment>
                            :
                            null
                    }
                    {/* <button className='details-card-join-btn' onClick={() => SetPage(MyEvents_PageMap.TICKETS)}>View Tickets</button> */}
                </div>
            )
        } else {
            return null;
        }
    }

    //exe function
    const GetKeyOfObjectByValue = (obj: any, value: any) => {
        let res = '';
        Object.keys(obj).map((key: string) => {
            if (obj[key] == value)
                res = key;
        });
        return res;
    }
    // const RefetchUserEvents = () => {
    //     databaseInterfaceController.Queue('fetchUserEvents', [
    //         ['fetchUserEvents', 'true'],
    //         ['userID', appContext.user.userID]
    //     ]);
    // } --deprecated
    const SnapRegistrationInfoTicket = () => {
        appContext.SetHeaderShouldHide(true);
        appContext.SetNavBarShouldHide(true);
        SetPage(MyEvents_PageMap.SNAP);
    }
    const TicketElemToCanvas = () => {
        if (ticketElemRef.current != undefined && ticketElemRef.current != null) {
            html2canvas(ticketElemRef.current).then(async (canvas) => {
                // Convert canvas to image data URL
                const base64String = canvas.toDataURL('image/jpg');
                const fileName = eventRegistrationReferrals[qrCardIndex].event_regRefID + '.jpg';

                await Filesystem.writeFile({
                    path: fileName,
                    data: base64String, // your data to write (ex. base64)
                    directory: /*Directory.Documents ---not working android 10 onwards*/Directory.Cache,
                    recursive: true
                });
                const uriRes = await Filesystem.getUri({
                    directory: Directory.Cache,
                    path: fileName
                });

                // Create a download link and click it to save the image
                if (shareModeRef.current == MyEvents_ShareModeMap.SHARE) {
                    try {
                        await Share.share({ url: uriRes.uri });
                    } catch (err) {
                        console.log('shareErr: ' + err);
                    }
                } else if (shareModeRef.current == MyEvents_ShareModeMap.DOWNLOAD) {
                    if (isPlatform('hybrid')) {
                        try {
                            Mediastore.saveToDownloads({
                                path: uriRes.uri,
                                filename: fileName
                            });
                            appContext.SetPopupMessage('File saved to /Download folder.');
                            appContext.SetPopupButtons(['ok']);
                            appContext.SetPopupActions([() => { }]);
                        } catch (err) {
                            console.log('DownloadErr: ' + err);
                        }
                    } else {
                        console.log('isPcDownload');
                        const link = document.createElement('a');
                        link.href = base64String;
                        link.download = fileName;
                        link.click();
                    }
                }
                SnapDone();
            });
        } else {
            clearTimeout(timeoutRef_ticketElemToCanvas.current!);
            timeoutRef_ticketElemToCanvas.current = setTimeout(() => {
                TicketElemToCanvas();
            }, 500);
        }
    }
    const SnapDone = () => {
        appContext.SetHeaderShouldHide(false);
        appContext.SetNavBarShouldHide(false);
        SetPage(MyEvents_PageMap.TICKETS);
    }
    const SortEventsByDate = (events: Event[], mode: number) => {
        const sorted = [] as Event[];
        events.map((event: Event) => {
            let isSorted = false;
            sorted.map((sort: Event, i: number) => {
                if (!isSorted &&
                    (event.event_start_datetime! && sort.event_start_datetime!) &&
                    (
                        mode == MyEvents_SortModeMap.DESCENDING ?
                            event.event_start_datetime >= sort.event_start_datetime
                            :
                            event.event_start_datetime < sort.event_start_datetime
                    )
                ) {
                    sorted.splice(i, 0, event);
                    isSorted = true;
                }
            });
            if (!isSorted)
                sorted.push(event);
        });

        return sorted;
    }
    const GetMembershipUserByID = (userID: string) => {
        let res = {} as MemberUser;
        exAppContext.membershipUsers.map((memberUser: MemberUser) => {
            if (memberUser.userID == userID)
                res = memberUser;
        });
        return res;
    }
    const NRICMask = (nric: string) => {
        return 'xxxxxx-xx-' + nric.substring(8, 12);
    }
    const FilterEventsBySearchString = (events: Event[]) => {
        let filtered = [] as Event[];
        if (filter_searchString != '') {
            events.map((event: Event) => {
                if (event.event_name.toUpperCase().includes(filter_searchString.toUpperCase())) {
                    filtered.push(event);
                }
            });
        } else
            filtered = events;
        return filtered;
    }
    const FilterEventsByCategory = (events: Event[]) => {
        let filtered = [] as Event[];
        if (filter_eventCategory != '') {
            events.map((event: Event) => {
                if (event.event_categoryID == filter_eventCategory)
                    filtered.push(event);
            });
        } else {
            filtered = events;
        }
        return filtered;
    }
    const FilterEventsMergeSameEvents = (events: Event[]) => {
        const res = [] as Event[];
        events.map((event: Event) => {
            let eventFound = false;
            res.map((_event: Event) => {
                if (_event.eventID == event.eventID)
                    eventFound = true;
            });

            if (!eventFound)
                res.push(event);
        });
        return res;
    }

    return (
        <div className={'MyEvents ' + ( appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='option-panel'>
                {RenderTopOptions()}
                {RenderBottomOptions()}
                {/* <div className='filter-panel'>
                    <span className='filter-panel-title'>Filter By</span>
                    <SelectionBox selectionList={selectionList_eventCategory} selectingKey={filter_eventCategory} SetSelectingKey={SetFilter_eventCategory} direction='up' />
                </div> ---deprecated */}
            </div>
            {
                RenderPages()
            }

            {/** SwipeOverscrollHandlers */}
            {/* <SwipeOverscrollHandler targetRef={eventScrollRef} action={() => RefetchUserEvents()} /> */}
            <SwipeOverscrollHandler targetRef={qrCardScrollMaskRef} direction='right-to-left' animation={false} action={() => OnNavigateToNextQr()} />
            <SwipeOverscrollHandler targetRef={qrCardScrollMaskRef} direction='left-to-right' animation={false} action={() => OnNavigateToPrevQr()} />
        </div>
    )
}
export default MyEvents;